import type { PassportMessageKey } from './passport.en'

/** Public Passport strings (Hindi), spread into hi.ts. The type forces every key. */
export const passportHi: Record<PassportMessageKey, string> = {
  'passport.tag': 'पासपोर्ट',
  'passport.switchTo': 'English',
  'passport.switchToLabel': 'Read in English',
  'passport.loading': 'पासपोर्ट खुल रहा है',
  'passport.error.title': 'यह पेज नहीं खुला',
  'passport.error.body': 'इंटरनेट देखें और फिर से कोशिश करें। फिर भी न खुले तो हमसे बात करें।',
  'passport.error.retry': 'फिर से कोशिश करें',

  'passport.photo': 'पाउच की फ़ोटो',
  'passport.released': '{date} को जारी',
  'passport.releasedNoDate': 'हमारी क्वालिटी टीम ने जारी किया',
  'passport.row.product': 'सामान',
  'passport.row.lotCode': 'लॉट कोड',
  'passport.row.packed': 'पैक हुआ',
  'passport.row.bestBefore': 'इससे पहले खाएँ',
  'passport.checkCode': 'देख लें कि यह लॉट कोड आपके पैक पर QR के पास छपे कोड से मिलता है।',

  'passport.tested.titleClean': 'जाँच हुई, कुछ नहीं मिला',
  'passport.tested.title': 'जाँच',
  'passport.tested.headClean': '{n} {n:कीटनाशक|कीटनाशकों} की जाँच: कोई नहीं मिला',
  'passport.tested.headFound': '{n} {n:कीटनाशक|कीटनाशकों} की जाँच: {found} मिले, सीमा के अंदर',
  'passport.tested.headNoPest': 'लैब के {n} नतीजे',
  'passport.tested.loqText':
    '{loq} या उससे ज़्यादा कोई नहीं मिला। यह सबसे कम मात्रा है जो लैब नाप सकती है (LOQ)। इसका मतलब शून्य नहीं है।',
  'passport.tested.loqFound':
    'हर नतीजा सीमा के अंदर है। {loq} से कम नतीजा, जो लैब की सबसे कम नापने लायक मात्रा (LOQ) है, "नहीं मिला" लिखा है। इसका मतलब शून्य नहीं है।',
  'passport.tested.notDetected': 'नहीं मिला',
  'passport.tested.ndLoq': 'नहीं मिला (LOQ {loq} {uom})',
  'passport.tested.withLimit': '{value} (सीमा {limit})',
  'passport.tested.lab': 'लैब',
  'passport.tested.accreditation': 'मान्यता',
  'passport.tested.date': 'जाँच हुई',
  'passport.tested.report': 'रिपोर्ट',
  'passport.tested.fullPanel': 'लैब के सारे नतीजे देखें ({n})',
  'passport.tested.hidePanel': 'सारे नतीजे छिपाएँ',
  'passport.tested.openReport': 'लैब रिपोर्ट खोलें (PDF)',

  'passport.origin.title': 'यह कहाँ से आया',
  'passport.origin.villageDistrict': '{village} गाँव, {district} ज़िला',
  'passport.origin.village': '{village} गाँव',
  'passport.origin.district': '{district} ज़िला',
  'passport.origin.oneFarmer': 'एक किसान की फसल',
  'passport.origin.line': '{crop}, {season}। अकेले प्रोसेस हुआ: एक किसान की फसल, पहले से साफ़ की गई मशीन पर।',
  'passport.origin.lineNoSeason': '{crop}। अकेले प्रोसेस हुआ: एक किसान की फसल, पहले से साफ़ की गई मशीन पर।',
  'passport.origin.consentBoth': 'उनका नाम और गाँव उनकी सहमति से दिखाया गया है।',
  'passport.origin.consentVillage': 'उनका गाँव उनकी सहमति से दिखाया गया है।',
  'passport.origin.consentNone': 'उनका गाँव और नाम तभी दिखाते हैं जब वे सहमति दें।',

  'passport.season.KHARIF': 'खरीफ़ {year}',
  'passport.season.RABI': 'रबी {year}',
  'passport.season.ZAID': 'ज़ायद {year}',

  'passport.grown.title': 'यह कैसे उगाया गया',
  'passport.grown.season': '{season} के मौसम में उनके रजिस्टर्ड खेत में उगाया गया',
  'passport.grown.field': 'उनके रजिस्टर्ड खेत में उगाया गया',
  'passport.grown.storage':
    'खरीद के समय उन्होंने बताया कि फसल 7 दिन से कम घर पर रखी गई और रखने में कोई दवा नहीं डाली गई',
  'passport.grown.bags': 'खरीदने से पहले हर बोरी खोलकर हाथ से जाँची गई',

  'passport.processed.title': 'यह कैसे प्रोसेस हुआ',
  'passport.processed.bought': '{place} में खेत के पास खरीदा गया',
  'passport.processed.boughtNoPlace': 'खेत के पास खरीदा गया',
  'passport.processed.godown': 'हमारे गोदाम में, जहाँ बिना दवा (फ्यूमिगेंट) के रखने का लिखित वादा है',
  'passport.processed.aloneBalanced': '{step}, अकेले, साफ़ की गई मशीन पर; अंदर और बाहर तौला गया',
  'passport.processed.alone': '{step}, अकेले, साफ़ की गई मशीन पर',
  'passport.processed.packed': 'लाइसेंस वाले हॉल में पैक हुआ',
  'passport.processed.tested': 'मान्यता प्राप्त लैब में जाँच हुई',
  'passport.processed.released': 'हमारी क्वालिटी टीम ने जाँचकर जारी किया',

  'passport.step.CLEAN': 'सफ़ाई हुई',
  'passport.step.DRY': 'सुखाया गया',
  'passport.step.DEHULL': 'छिलका उतारा गया',
  'passport.step.SPLIT': 'दो फाड़ किया गया',
  'passport.step.POLISH': 'पॉलिश हुई',
  'passport.step.GRADE': 'छँटाई हुई',
  'passport.step.SORT': 'बीनाई हुई',
  'passport.step.PACK': 'पैक हुआ',

  'passport.footer.questions': 'इस पैक के बारे में सवाल?',
  'passport.footer.note': 'यह पेज इस लॉट के हमारे रिकॉर्ड से बनता है। इसे कोई हाथ से नहीं बदलता।',
  'passport.contact.call': '{phone} पर कॉल करें',
  'passport.contact.whatsapp': 'WhatsApp {phone}',
  'passport.contact.email': 'ईमेल {email}',

  'passport.warn.whatToDo': 'क्या करें',
  'passport.warn.contactUs': 'हमसे बात करें',

  'passport.warn.HELD.title': 'यह लॉट रोका गया है',
  'passport.warn.HELD.body': 'जब तक हम इस लॉट की जाँच पूरी न करें, पैक बंद रखें। हम यह पेज बदल देंगे।',
  'passport.warn.HELD.step1': 'पैक बंद रखें।',
  'passport.warn.HELD.step2': 'कुछ दिन बाद फिर स्कैन करें, या हमसे बात करें।',
  'passport.warn.HELD.step3': 'पैसे अभी वापस चाहिए? जिस दुकान से खरीदा, वहाँ लौटा दें।',
  'passport.warn.HELD.since': '{date} से रोका गया',
  'passport.warn.HELD.foot': 'रोके जाने तक इस लॉट की लैब जानकारी नहीं दिखाई जाती।',

  'passport.warn.RECALLED.title': 'वापस मंगाया गया: न खाएँ',
  'passport.warn.RECALLED.body': 'इस लॉट की लैब जाँच हमारे मानक पर खरी नहीं उतरी। कृपया यह पैक न खाएँ।',
  'passport.warn.RECALLED.step1': 'इसे न खाएँ, और किसी को न दें।',
  'passport.warn.RECALLED.step2': 'पूरे पैसे वापस पाने के लिए दुकान पर लौटाएँ, या हमें कॉल करें, हम ले जाएँगे।',
  'passport.warn.RECALLED.step3': 'सेहत को लेकर सवाल? हमें कॉल करें, हम मदद करेंगे।',
  'passport.warn.RECALLED.since': '{date} को वापस मंगाया गया',
  'passport.warn.RECALLED.foot': 'वापस मंगाए गए लॉट की लैब जानकारी नहीं दिखाई जाती।',

  'passport.warn.NOT_RELEASED.title': 'अभी जारी नहीं हुआ',
  'passport.warn.NOT_RELEASED.body':
    'हमने इस लॉट की जाँच पूरी नहीं की है, इसलिए यह अभी बिक्री में नहीं होना चाहिए। कृपया पैक बंद रखें।',
  'passport.warn.NOT_RELEASED.step1': 'पैक बंद रखें।',
  'passport.warn.NOT_RELEASED.step2': 'हमें बताएँ कि किस दुकान से खरीदा, ताकि हम पता करें।',
  'passport.warn.NOT_RELEASED.step3': 'कुछ दिन बाद फिर स्कैन करें। लॉट जारी होते ही यह पेज बदल जाएगा।',
  'passport.warn.NOT_RELEASED.since': '{date} को पैक हुआ',
  'passport.warn.NOT_RELEASED.foot': 'लॉट जारी होने पर इसकी लैब जानकारी दिखेगी।',

  'passport.warn.WITHDRAWN.title': 'बिक्री से हटाया गया',
  'passport.warn.WITHDRAWN.body': 'यह लॉट बिक्री से हटा दिया गया है। कृपया यह पैक न खाएँ।',
  'passport.warn.WITHDRAWN.step1': 'इसे न खाएँ, और किसी को न दें।',
  'passport.warn.WITHDRAWN.step2': 'पूरे पैसे वापस पाने के लिए दुकान पर लौटाएँ, या हमसे बात करें।',
  'passport.warn.WITHDRAWN.step3': 'सेहत को लेकर सवाल? हमें कॉल करें, हम मदद करेंगे।',
  'passport.warn.WITHDRAWN.since': '{date} को हटाया गया',
  'passport.warn.WITHDRAWN.foot': 'बिक्री से हटाए गए लॉट की लैब जानकारी नहीं दिखाई जाती।',

  'passport.warn.PASSPORT_PREPARING.title': 'जानकारी तैयार हो रही है',
  'passport.warn.PASSPORT_PREPARING.body': 'यह लॉट जारी हो चुका है, पर इसका पेज अभी तैयार नहीं है। थोड़ी देर बाद फिर स्कैन करें।',
  'passport.warn.PASSPORT_PREPARING.step1': 'एक दिन बाद फिर स्कैन करें।',
  'passport.warn.PASSPORT_PREPARING.step2': 'अभी सवाल है? हमसे बात करें।',
  'passport.warn.PASSPORT_PREPARING.step3': 'देख लें कि लॉट कोड QR के पास छपे कोड से मिलता है।',
  'passport.warn.PASSPORT_PREPARING.since': '{date} को पैक हुआ',
  'passport.warn.PASSPORT_PREPARING.foot': 'यह पेज इस लॉट के हमारे रिकॉर्ड से बनता है। इसे कोई हाथ से नहीं बदलता।',

  'passport.nf.title': 'यह कोड हमें नहीं मिला',
  'passport.nf.opened': 'आपने जो कोड खोला',
  'passport.nf.why': 'हमारे लॉट कोड के आखिर में एक जाँच-अक्षर होता है, इसलिए गलत कॉपी या टाइप किया कोड कोई पेज नहीं खोलता।',
  'passport.nf.typeTitle': 'पैक से कोड टाइप करें',
  'passport.nf.typeHint': 'यह QR के पास, “LOT” के बाद छपा है।',
  'passport.nf.inputLabel': 'लॉट कोड',
  'passport.nf.badShape': 'लॉट कोड ऐसा दिखता है: PL-2026-1112-0001-H। कृपया जाँच लें।',
  'passport.nf.lookUp': 'खोजें',
  'passport.nf.stillTitle': 'फिर भी नहीं मिला?',
  'passport.nf.stillBody': 'हो सकता है यह पैक हमारा न हो। कृपया बताएँ कि कहाँ से खरीदा, ताकि हम पता करें।',
  'passport.nf.noted': 'हमने यह स्कैन दर्ज कर लिया है।',

  'passport.meta.title': '{district} से {product} · अनकम्प्रोमाइज़्ड पासपोर्ट',
  'passport.meta.description':
    '{district} के एक किसान का {crop}: कैसे उगाया, प्रोसेस किया और जाँचा गया। पैक लॉट {code}।',
  'passport.meta.warnTitle': 'पैक लॉट {code} · अनकम्प्रोमाइज़्ड',
  'passport.meta.warnDescription': 'अनकम्प्रोमाइज़्ड उत्पाद पासपोर्ट।',
  'passport.meta.loading': 'अनकम्प्रोमाइज़्ड पासपोर्ट',
}
